var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3628 10.1387C17.3628 14.4437 13.869 17.9376 9.56399 17.9376C5.25902 17.9376 1.76514 14.4437 1.76514 10.1387C1.76514 5.83373 5.25902 2.33984 9.56399 2.33984C13.869 2.33984 17.3628 5.83373 17.3628 10.1387Z",
    stroke: "#797979",
    strokeWidth: 1.1355,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4568 12.6184L10.0392 11.1757C9.61805 10.9261 9.2749 10.3256 9.2749 9.83425V6.63672",
    stroke: "#797979",
    strokeWidth: 1.1355,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.0820fba6e7c8ebf8e62a192efad6da7e.svg";
export { ForwardRef as ReactComponent };